import RoleList from '@Role/views/RoleList.vue';
import permissions from '@Share/config/permissions';

export default [
  {
    path: '/roles',
    name: 'roles',
    component: RoleList,
    meta: {
      requiresAuth: true,
      layout: 'accountLayout',
      title: 'Roles',
      permissions: [permissions.Roles.View],
    },
  },
];
